export default {
    _prefix: "AgreementRate",
    label: "Agreement Score",
    percentage: (data: { percentage: number }) => "{{percentage}}%",
    tooltip: {
        draftFormAgreementRateInfo:
            "Click 'View published form' to see agreement rates for automated questions on the last published form.",
        generalAgreementRateInfo:
            "Agreement score shows how often users accepted AI-suggested or EA-suggested answers. Well-written questions and help text typically lead to higher scores.",
    },
    draftFormAgreementRateLabel: "Published form agreement score",
    viewPublishedForm: "View published form",
    ariaLabels: {
        agreementRatePercentage: (data: { percentage: number }) =>
            "{{percentage}} percent agreement score",
        externalLinkIcon: "In a new tab",
    },
};
